module.exports = __webpack_public_path__ + "static/media/MyResume.4c5d4117.pdf";